'use client';

import { FC } from 'react';
import { CardContent } from '@/_components';
import { ClientMessagesContentProps } from './ClientMessagesContent.types';
import { ClientChatHeader } from './components/ClientChatHeader';
import { ClientChatContent } from './components/ClientChatContent';

export const ClientMessagesContent: FC<ClientMessagesContentProps> = () => {
  return (
    <CardContent
      isFullHeight={true}
      data-testid="MessagesPage-conversation-content"
    >
      <ClientChatHeader />
      <ClientChatContent />
    </CardContent>
  );
};
